import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

// Persistent floating "Back to Top" button — appears once the page is scrolled down.
export const BackToTop = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  return (
    <button data-testid="coach-back-to-top" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Back to top"
      className="fixed bottom-6 right-6 z-[70] flex items-center gap-2 bg-[#C41E24] hover:bg-[#A0161D] text-white text-xs font-bold uppercase tracking-wider px-4 py-3 rounded-full shadow-[0_10px_30px_rgba(196,30,36,0.4)] transition-colors">
      <ArrowUp size={16} /> <span className="hidden sm:inline">Top</span>
    </button>
  );
};

export default BackToTop;
